<template>
    <section ref="headerRef" style="visibility:visible;" :class="[shit$(`dis:f; align-i:c; white-space:nowrap;`)]">
        <template v-for="(o, i) in headerData">
            <template>
              <p :class="[shit$(`mx:5px;`)]" v-if="i" :key="i + o.query.folderId + o.label">&gt;</p>
              <template v-if="i >= defultIndex + 1">
                <p @click="isHeaderPathChangeT(info, o, 'path') && $emit('getClickMsg', o)" :class="[shit$(`p:4px; radius:4px; hover:bgc:rgba(255, 255, 255, 0.1);`)]" :key="i + o.query.folderId">
                  {{ isLastIndexT(headerData, i) && o.label.length > modeMp.len.a ? formatStringSubstrT(o.label, { s: 0, e: modeMp.len.a }, '..') : o.label.length > modeMp.len.b ? formatStringSubstrT(o.label, { s: 0, e: modeMp.len.b }, '..') : o.label }}
                </p> 
              </template>
              <template v-if="defultIndex + 1 > i">
                <p @click="isHeaderPathChangeT(info, o, 'path') && $emit('getClickMsg', o)" :class="[shit$(`p:4px; radius:4px; hover:bgc:rgba(255, 255, 255, 0.1);`)]" :key="i + o.query.folderId">
                  {{ o.label }}
                </p> 
              </template>
            </template>
      
            <template v-if="toolData.length && i === defultIndex">
                <div :key="o + i" :class="shit$(`relative; z:100;`)">
                    <div @click="toolSwitch = !toolSwitch" :class="[shit$(modeMp.style), shit$(`hover:bgc:#ffffff1a; dis:f; align-i:c; justify-c:sb; radius:4px;`)]">
                      <template v-for="o in 3">
                        <p :class="shit$(`w:4px; h:4px; bgc:#fff; radius:50%; `)" :key="o"></p>
                      </template>
                    </div>
                    <el-collapse-transition>
                        <section v-show="toolSwitch" :class="shit$(`mxh:190px; overflow:a; mt:11px; radius:4px; b:1px; bc:#a8a8ac; absolute; w:180px; pt:6px; pb:7px; bgc:#272727; font:12px; letter-s:0.69px; box-shadow: 0 2px 4px 0 #444444;`)">
                          <p v-for="(o, i) in toolData"
                            @click="isHeaderPathChangeT(info, o, 'path') && $emit('getClickMsg', o)"
                            :key="o + i" :class="shit$(`w:100%; pl:10px; h:25px; lh:25px; hover:bgc:#444; hover:c:#0ed3ff;`)">
                            {{ o.label.length > 11 ? formatStringSubstrT(o.label, { s: 0, e: 7 }, '..') + o.label.substr(-4) : o.label }}
                          </p>
                        </section>
                    </el-collapse-transition>
                </div>
            </template>
        </template>
    </section>
</template>
<script>
import MixTool from '@/code-lab/component/file-management/mixins/tool-mix.js'
import { mapState } from 'vuex'
export default {
  mixins: [ MixTool ],
  props: {
    info: Array,
    mode: Number
  },
  data () {
    return {
      offSetWidth: 0,
      scrollWidth: 0,
      toolData: [],
      headerData: [],
      toolSwitch: false,
      handleResizeTimer: null,

    }
  },
  computed: {
    ...mapState(['currentVersion']),
    defultIndex () {
      const m = { teacher: 1, public: 0, family: 0, student: 0 }
      return m[this.currentVersion]
    },
    modeMp () {
      const shit = { 0: { style: 'h:28px; w:48px; px:14px;', len: { a: 10, b: 7 } }, 1: { style: 'h:24px; w:30px; px:5px;', len: { a: 5, b: 3 } } }
      return shit[this.mode]
    }
  },
  methods: {
    updateOffsetWidth () {
      this.offSetWidth = this.$refs.headerRef.offsetWidth
    },
    updateScrollWidth() {
      this.scrollWidth = this.$refs.headerRef.scrollWidth
    },
    adaptLayout () {
      if (this.scrollWidth > this.offSetWidth) {
        this.$refs.headerRef.style.visibility = 'hidden'
        const fn = () => {
          if (this.scrollWidth > this.offSetWidth) {
            this.toolData = [...this.toolData, ...this.headerData.splice(this.defultIndex + 1, 1)]
            setTimeout(() => {
                this.updateOffsetWidth()
                this.updateScrollWidth()
                fn()
                console.log('adaptLayout', 1)
            }, 0)
          } else {
            console.log('adaptLayout', 2)
            this.$nextTick(() => {
              this.$refs.headerRef.style.visibility = 'visible'
            })
          }
        }
        fn()
      }
    },
    handleResize () {
      console.log('adaptLayout', 3)
      if (this.handleResizeTimer) {
        window.clearTimeout(this.handleResizeTimer)
        this.handleResizeTimer = null
      }
      // this.$refs.headerRef.style.visibility = 'hidden'

      this.handleResizeTimer = setTimeout(() => {
        if (this.$refs.headerRef.offsetWidth <= this.$refs.headerRef.scrollWidth) {
          this.toolData = []
          this.headerData = JSON.parse(JSON.stringify(this.info))
        } else {
           console.log('adaptLayout', 4)
        }
        this.$nextTick(() => {
          this.updateOffsetWidth()
          this.updateScrollWidth()
          this.adaptLayout()
        })
      }, 300)
    }
  },
  mounted () {
    this.headerData = JSON.parse(JSON.stringify(this.info))
    this.$nextTick(() => {
      this.updateOffsetWidth()
      this.updateScrollWidth()
      this.adaptLayout()
    })
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    info: {
      handler (newValue, oldValue) {
        Object.assign(this, { toolSwitch: false })
        if (oldValue.length > newValue.length) {
          Object.assign(this, { toolData: [] })
          this.headerData = JSON.parse(JSON.stringify(newValue))
        } else {
          if (this.toolData.length) {
            this.headerData = JSON.parse(JSON.stringify([...newValue.slice(0, this.defultIndex + 1), ...newValue.slice(this.toolData.length + this.defultIndex + 1),]))
          } else {
            this.headerData = JSON.parse(JSON.stringify(newValue))
          }
        }
        this.$nextTick(() => {
          this.updateOffsetWidth()
          this.updateScrollWidth()
          this.adaptLayout()
        })
      }
    },
  },
}
</script>

